module.exports = __webpack_public_path__ + "static/img/c3.b5046d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/c3.png
// module id = aoBr
// module chunks = 1